// lib/store.ts
import { configureStore } from '@reduxjs/toolkit';

import authReducer from './slices/authSlice';
import searchTripReducer from './slices/searchTripSlice';
import tripResultsReducer from './slices/tripResultsSlice';
import bookingReducer from './slices/bookingSlice';
import adminBookingReducer from './slices/adminBookingSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    searchTrip: searchTripReducer,
    tripResults: tripResultsReducer,
    booking: bookingReducer,
    adminBooking: adminBookingReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 